<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-4  step-list">
        <div
          :class="{active: index == activeStep, step: true}"
          v-for="(child, index) in children"
          :key="child._uid"
          @click="setActive(index)"
        >
          <div class="row align-items-center">
            <div class="col-9 d-none d-sm-block">
              <h5 class="text-uppercase" style="margin-bottom: 0; word-wrap: normal;">{{child.$props.title}}</h5>
            </div>
            <div class="col-3">
              <div :class="`icon icon-shape text-${index <= activeStep ? 'white' : 'blue'} rounded-circle shadow bg-gradient-${index <= activeStep ? index == activeStep ? 'blue' : 'green' : 'primary'}`">
                <i v-if="child.$props.icon" :class="['fa', child.$props.icon]"></i>
                <strong v-else>{{index + 1}}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col" ref="tabs">
        <slot/>
      </div>
    </div>
    <div class="row justify-content-end">
      <base-button class="mr-5" v-loading="loading" @click="$emit('save')" v-if="activeStep != children.length - 1 && help == false" type="primary">Salvar</base-button>
      <base-button class="mr-2" @click="$emit('update'); activeStep -= 1" v-if="activeStep > 0 && activeStep != children.length - 1 && help == false">Anterior</base-button>
      <base-button @click="$emit('update'); activeStep += 1" v-if="activeStep != children.length - 1 && help == false">Próximo</base-button>
      <base-button v-loading="loading" @click="$emit('save')" v-if="activeStep == children.length - 1 && help == false" type="primary">Salvar</base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from '../BaseButton.vue'
export default {
  components: { BaseButton },
  name: "wizard",
  props: {
    sideColor: {
      type: String,
      default: 'info',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    help: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      activeStep: 0,
      children: [],
    }
  },
  methods: {
    setActive(step){
      this.activeStep = step
      this.$emit('change', step)
    },
  },
  mounted() {
    this.children = this.$children.filter(child => child.$options._componentTag == "wizard-tab")
    this.children[0].$data.show = true
  },
  watch: {
    activeStep(newVal){
      this.children.forEach((child, index) => child.$data.show = index == newVal)
    },
  },
}
</script>

<style lang="scss" scoped>
  .step-list {
    padding-right: 10px;
    margin-right: 20px;
    border-right: 1px solid #02020226;
    .step {
      cursor: pointer;
      margin: 10px 25px 25px 0;
    }
  }
</style>